import { Dialog as DialogPrimitive } from "@base-ui/react/dialog"
import { X } from "@phosphor-icons/react"
import * as React from "react"

function Dialog({ ...props }: DialogPrimitive.Root.Props) {
  return <DialogPrimitive.Root {...props} />
}

function DialogTrigger({ ...props }: DialogPrimitive.Trigger.Props) {
  return <DialogPrimitive.Trigger data-slot="dialog-trigger" {...props} />
}

function DialogClose({ style, ...props }: DialogPrimitive.Close.Props & { style?: React.CSSProperties }) {
  return (
    <DialogPrimitive.Close
      data-slot="dialog-close"
      style={{
        display: 'grid',
        placeItems: 'center',
        width: 44,
        height: 44,
        padding: 0,
        border: 'none',
        borderRadius: 'var(--naia-r-sm)',
        background: 'transparent',
        color: 'var(--naia-text-secondary)',
        cursor: 'pointer',
        font: 'inherit',
        ...style,
      }}
      {...props}
    />
  )
}

function DialogContent({
  children,
  style,
  showCloseButton = true,
  ...props
}: DialogPrimitive.Popup.Props & { style?: React.CSSProperties; showCloseButton?: boolean }) {
  return (
    <DialogPrimitive.Portal>
      <DialogPrimitive.Backdrop
        style={{
          position: 'fixed',
          inset: 0,
          background: 'rgba(7,16,28,0.50)',
          zIndex: 100,
        }}
      />
      <DialogPrimitive.Popup
        data-slot="dialog-content"
        style={{
          position: 'fixed',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          zIndex: 101,
          background: 'var(--naia-card)',
          border: '1px solid var(--naia-line)',
          borderRadius: 'var(--naia-r-md)',
          boxShadow: 'var(--naia-shadow-card)',
          display: 'flex',
          flexDirection: 'column',
          maxHeight: '90vh',
          width: '90vw',
          maxWidth: '700px',
          ...style,
        }}
        {...props}
      >
        {children}
        {showCloseButton && (
          <DialogClose
            aria-label="Fermer"
            style={{ position: 'absolute', top: 6, right: 6, zIndex: 1 }}
          >
            <X size={20} weight="bold" />
          </DialogClose>
        )}
      </DialogPrimitive.Popup>
    </DialogPrimitive.Portal>
  )
}

function DialogHeader({ ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      data-slot="dialog-header"
      style={{ padding: '16px 56px 12px 20px', borderBottom: '1px solid var(--naia-line)', flexShrink: 0 }}
      {...props}
    />
  )
}

function DialogTitle({ ...props }: DialogPrimitive.Title.Props) {
  return (
    <DialogPrimitive.Title
      data-slot="dialog-title"
      style={{ margin: 0, fontSize: 16, fontWeight: 700, color: 'var(--naia-text-primary)' }}
      {...props}
    />
  )
}

export { Dialog, DialogTrigger, DialogContent, DialogHeader, DialogTitle, DialogClose }
